export const homepageNewsItemsCount: number = 26;
export const headlineNewsItemsCount: number = 2;
export const relatedNewsItemsCount: number = 3;
export const searchResultsItemsCount: number = 5;
export const paginationLimit: number = 7;
export const vacanciesOverviewItemsCount: number = 12;
export const MINIMAL_SEARCH_CHARACTERS: number = 3;
export const SHORT_MESSAGE_LENGTH_THRESHOLD: number = 500;
export const MINIMAL_CONFIDENCE_LEVEL_PEOPLE_FINDER: number = 20;
export const MAXIMAL_RESULTS_PEOPLE_FINDER: number = 25;

// Theme constants
export const themeLight = "light";
export const themeDark = "dark";
export const themeSystem = "system";
export type Theme = typeof themeLight | typeof themeDark | typeof themeSystem;

// API routes
export const API_ROUTES = {
  articleLike: "/api/v1/user/article-like",
  articleLikeCount: "/api/v1/article/like-count",
  articlesRead: "/api/v1/user/articles-read",
  notifications: "/api/v1/user/notifications",
  peopleFinder: "/v1/employees/search",
  preference: "/api/v1/user/preference",
  privateAsset: "/api/v1/storyblok-asset",
  subtitles: "/api/v1/subtitles",
  vacancies: "/api/v1/vacancies",
  vacancy: (slug: string) => `/api/v1/vacancies/${slug}`,
  vacancyForm: (formId: string) => `/api/v1/vacancies/form/${formId}`,
  vacancyFilters: "/api/v1/vacancy-filters",
  walkthroughsFinished: "/api/v1/user/walkthrough-finished",
  omniSearch: {
    // Chat management endpoints (currently in use)
    chats: "/api/v2/chats",
    chat: (sessionId: string) => `/api/v2/chats/${sessionId}`,
    chatTitle: (sessionId: string) => `/api/v2/chats/${sessionId}/title`,
    sources: "/api/v2/services/pulse-url",
  },
};

export const VACANCY_FORM_SOURCE = "Source: Direct";

export const PeopleFinder = "people-finder";
export const DateFormatNL = "nl-NL";
export const DateFormatEN = "en-US";

export const languages = {
  en: "English",
  nl: "Nederlands",
};

// Tracking metadata keys (sent via window.sa_metadata to Simple Analytics)
export const TrackingParam = {
  // UPEI stands for "Unique Pon Employee ID"
  upei: "upei",
  userType: "user_type",
  contentType: "content_type",
  contentLanguage: "content_language",
  articleCluster: "article_cluster",
} as const;

export const UserType = {
  leader: "leader",
  employee: "employee",
} as const;
export type UserType = (typeof UserType)[keyof typeof UserType];

export const ContentType = {
  article: "article",
  corporateService: "corporate_service",
  systemPage: "system_page",
  contentPage: "content_page",
  homepage: "homepage",
} as const;
export type ContentType = (typeof ContentType)[keyof typeof ContentType];

// Path segments used to derive the content type from the URL
export const ContentTypePathSegment = {
  news: "news",
  corporateServices: "corporate-services",
  vacancies: "vacancies",
  settings: "settings",
} as const;

export const Department = "Department";
